import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'esWaitingRoomBadge',
  props: {
    text: {},
    color: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "waiting-room-badge flex-center",
    style: _normalizeStyle({background: props.color})
  }, [
    _createElementVNode("p", null, _toDisplayString(props.text), 1)
  ], 4))
}
}

})